/** @file entryResizeFields: the facet.setEntry fields a size / pivot change sends (null: nothing changed). */

const EPS = 1e-9;

/** An entry's size and pivot pixel (`pivotFrac x size`, image px) before (`size0`, `pivot0`) and after a change. */
export type EntryResize = {
  drawable: string; entry: number; size0: readonly [number, number]; pivot0: readonly [number, number];
  size: readonly [number, number]; pivot: readonly [number, number];
};

/** The changed fields; `pivotFrac` is new pivot / new size. */
export type EntryResizeFields = { size?: [number, number]; pivotFrac?: [number, number] };

/**
 * `size` when it changed, `pivotFrac` when the fraction changed (a pivot pixel kept at the max edge keeps its pixel and
 * its fraction changes with the size); null when neither did.
 */
export function entryResizeFields(e: Omit<EntryResize, 'drawable' | 'entry'>): EntryResizeFields | null {
  const sized = e.size[0] !== e.size0[0] || e.size[1] !== e.size0[1];
  const frac: [number, number] = [e.pivot[0] / e.size[0], e.pivot[1] / e.size[1]];
  const fracChanged = Math.abs(frac[0] - e.pivot0[0] / e.size0[0]) > EPS || Math.abs(frac[1] - e.pivot0[1] / e.size0[1]) > EPS;
  if (!sized && !fracChanged) return null;
  return { ...(sized ? { size: [e.size[0], e.size[1]] } : {}), ...(fracChanged ? { pivotFrac: frac } : {}) };
}
